module.exports = __webpack_public_path__ + "img/iso_20000.ad660261.svg";